import { render } from "./Recetas.vue?vue&type=template&id=039e178a&scoped=true"
import script from "./Recetas.vue?vue&type=script&lang=js"
export * from "./Recetas.vue?vue&type=script&lang=js"

import "./Recetas.vue?vue&type=style&index=0&id=039e178a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-039e178a"]])

export default __exports__